<template>
  <base-material-card
    id="multiple-bar"
    color="primary"
    icon="mdi-poll-box"
    class="px-1 py-3"
    title="Relatórios Gráficos"
  >
    <div class="text-left dark-grey--text text-h4 font-weight-light">
      Selecione o laticínio e visualize os seus respectivos relatórios gráficos
    </div>
    <v-row>
      <v-col
        cols="12"
        lg="5"
      >
        <v-select
          :v-model="laticinio.select"
          :items="laticinio.items"
          item-text="nome"
          item-value="id"
          :disabled="disabledSelectLaticinio"
          return-object
          :label="laticinio.label"
          @change="onChange($event)"
        >
          <template
            v-slot:append-outer
          >
            <v-btn
              class="mt-n2 mr-1"
              elevation="1"
              fab
              small
              color="primary"
              type="submit"
              @click="carregaGraficos()"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-divider class="ma-3" />
    <v-row>
      <v-col
        cols="12"
        lg="6"
      >
        <dashboard-grafico-barras
          :dados="dadosGraficoEntregaLeite"
          :titulo="'Entrega de Leite'"
          :subtitulo="'Comparativo Mensal'"
          :serie1="serie1"
          :serie2="serie2"
        />
        <v-divider class="ma-3" />
      </v-col>
      <!-- <v-col
        cols="12"
        lg="6"
      >
        <dashboard-grafico-barras
          :titulo="'Contas a Pagar'"
          :subtitulo="'Comparativo Mensal'"
          :serie1="'2020'"
          :serie2="'2021'"
        />
        <v-divider class="ma-3" />
      </v-col>
      <v-col
        cols="12"
        lg="6"
      >
        <dashboard-grafico-barras
          :titulo="'Contas a Receber'"
          :subtitulo="'Comparativo Mensal'"
          :serie1="'2020'"
          :serie2="'2021'"
        />
      </v-col> -->
    </v-row>
  </base-material-card>
</template>

<script>
  import RecepcaoProdutoService from '../../../services/recepcaoprodutoservice'
  export default {
    name: 'DashboardGraficosForm',

    components: {
      DashboardGraficoBarras: () => import('../graficos/GraficoBarras'),
    },

    data: () => ({
      disabledSelectLaticinio: false,
      produtorId: 0,
      laticinio: {
        label: 'Laticínio',
        select: { id: 0, nome: 'Nenhuma informação encontrada' },
        items: [
          { id: 0, nome: 'Nenhuma informação encontrada' },
        ],
        totalQtde: 0,
      },
      dadosGraficoEntregaLeite: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        series: [
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        ],
      },
      serie1: '',
      serie2: '',
    }),

    computed: {

    },

    watch: {

    },

    mounted () {
      this.carregaForm()
    },
    methods: {
      onChange (event) {
        this.laticinio.select = event
      },
      carregaForm () {
        // this.loading_laticinios = true
        var dataHoje = new Date()
        this.serie2 = dataHoje.getFullYear().toString()
        this.serie1 = (this.serie2 - 1).toString()
        this.carregaLaticinios()
      },
      carregaLaticinios () {
        if (this.laticinio.select.id === 0) {
          // this.loading_laticinios = true
          RecepcaoProdutoService.listarLaticinios(localStorage.chaveativacao).then(resposta => {
            if (resposta.data.empresas.length > 0) {
              this.laticinio.items = resposta.data.empresas
              this.produtorId = resposta.data.empresas[0].produtor_id
              this.laticinio.select.id = resposta.data.empresas[0].id
              if (resposta.data.empresas.length === 1) {
                this.laticinio.select = resposta.data.empresas[0]
                this.laticinio.label = resposta.data.empresas[0].nome
                this.disabledSelectLaticinio = true
                this.carregaGraficos()
              }
            }
            // this.loading_laticinios = false
            this.appOnline = true
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
              this.carregaDadosOffline()
            } else {
              console.log('Erro listarLaticinios():', e.response)
            }
            // this.loading_laticinios = false
          })
        } else {
          var laticinio = this.laticinio.items.find(item => item.id === this.laticinio.select.id)
          this.produtorId = laticinio.produtor_id
          // this.loading = true
          this.carregaGraficos()
        }
      },
      carregaGraficos () {
        RecepcaoProdutoService.listarGrafico(localStorage.chaveativacao, this.laticinio.select.id, this.produtorId).then(resposta => {
          this.dadosGraficoEntregaLeite.series = resposta.data.series
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.log('Erro listarGrafico EntregaLeite(): ' + e.response)
            this.$router.push('/')
          }
          // this.loading_laticinios = false
        })
      },
    },
  }
</script>

<style scoped>

</style>
